import { useEffect } from "react";
import { UseFormReturn } from "react-hook-form";
import { OrdenTrabajo } from "@/shared/interfaces";
import { mapearOrdenTrabajoAFormValues } from "./mapearOrdenTrabajoAFormValues";

interface UseResetFormWithOTDataParams {
  form: UseFormReturn<any>;
  ordentrabajo: OrdenTrabajo;
  setMaterialesUtilizados: (materiales: any[]) => void;
  setProductosAdicionales: (productos: any[]) => void;
}

export function useResetFormWithOTData({
  form,
  ordentrabajo,
  setMaterialesUtilizados,
  setProductosAdicionales,
}: UseResetFormWithOTDataParams) {
  useEffect(() => {
    if (!ordentrabajo?.id_orden_trabajo) return;

    if (ordentrabajo.materiales_utilizados?.length > 0) {
      setMaterialesUtilizados(ordentrabajo.materiales_utilizados as any[]);
    }
    if (ordentrabajo.materiales_equipos_adicionales?.length > 0) {
      setProductosAdicionales(ordentrabajo.materiales_equipos_adicionales as any[]);
    }

    const formaPagoActual = form.getValues()?.forma_pago_adicionales_tecnico;
    const valores = mapearOrdenTrabajoAFormValues(ordentrabajo, formaPagoActual);
    form.reset(valores);
  }, [ordentrabajo]);
}